import { render } from "./historicoTarjetasVerificadas.vue?vue&type=template&id=78bd356a"
import script from "./historicoTarjetasVerificadas.vue?vue&type=script&lang=js"
export * from "./historicoTarjetasVerificadas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__